import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Buttonatom from "../../components/atom/Buttonatom";
import Formselectatom from "../../components/atom/Formselectatom";
import Functionalitiesbtn from "../../components/atom/Functionalitiesbtn";
import Createdcustomer from "../../components/creators/Createdcustomer";
import Filterinvoice from "../../components/Modals/Filterinvoice";
import ModalInvoiceTransac from "../../components/Modals/ModalInvoiceTransac";
import Paginationdesign from "../../components/Paginationdesign";
import TableInvoice from "../../components/Show/TableInvoice";
import LoadingScreen from "../../layout/LoadingScreen";
import { getCustomerThunk } from "../../store/slices/customer.slice";
import {
	deleteInvoiceThunk,
	getInvoiceThunk,
	postInvoiceTransacthunk,
	updateInvoiceThunk,
} from "../../store/slices/invoice.slice";
import { setIsLoading } from "../../store/slices/isLoading.slice";
import { setPagination } from "../../store/slices/pagination.slice";
import { getRouteDayThunk } from "../../store/slices/routeday.slice";
import { getSellerThunk } from "../../store/slices/seller.slice";
import date from "../../utils/date";

const Invoice = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		invoice[0] ? null : dispatch(getInvoiceThunk());
		routeDay[0] ? null : dispatch(getRouteDayThunk());
	}, []);

	const routeDay = useSelector((state) => state.routeDay);
	const invoice = useSelector((state) => state.invoice);
	const loading = useSelector((state) => state.isLoading);
	const pagination = useSelector((state) => state.pagination);
	const user = useSelector((state) => state.userLoged);

	const [modalShow, setModalShow] = useState(false);
	// console.log(invoice);
	const createdCustomer = () => {
		if (!modalShow) {
			setModalShow(true);
		} else {
			setModalShow(false);
		}
	};
	// const dataIfn = [
	// 	{ name: "John Doe", age: 25, email: "john@example.com" },
	// 	{ name: "Jane Smith", age: 30, email: "jane@example.com" },
	// 	// Agrega más datos aquí...
	// ];

	const btnCreated = () => {
		return (
			<>
				<Buttonatom
					isTrueOfElse={
						!user.roll?.permissions?.edited_seller_maxtotal
					}
					created={createdCustomer}
					title={"Crear Cliente"}
					color={"success"}
					ico={"fa-circle-plus"}
				/>

				<Buttonatom
					isTrueOfElse={
						!user.roll?.permissions?.edited_seller_maxtotal
					}
					created={transaccionPay}
					title={"Pago-Abono"}
					color={"success"}
					ico={"fa-sack-dollar"}
				/>

				<Buttonatom
					created={refresh}
					title={""}
					color={"info"}
					ico={"fa-arrow-rotate-right bx-spin-hover"}
				/>
				<Buttonatom
					created={() => setModalFilter(true)}
					title={""}
					color={"primary"}
					ico={"fa-filter"}
				/>
				{/*Boton que permite descargar  facturas y notas de venta */}
				<Buttonatom
					created={() => generarArchivoExcel(invoice, false)}
					title={"Exel General"}
					color={"warning"}
					ico={"fa-download"}
				/>

				{/*Boton que permite descargar solo facturas */}
				<Buttonatom
					created={() => generarArchivoExcel(invoice, true)}
					title={"Exel Facturas"}
					color={"warning"}
					ico={"fa-download"}
				/>
			</>
		);
	};
	/************************************************************************************** */

	const createInvo = (data) => {
		// Swal.fire({
		// 	position: "center",
		// 	icon: "success",
		// 	title: "Se a creado una Factura nueva",
		// 	showConfirmButton: false,
		// 	timer: 1500,
		// });
		dispatch(postInvoiceTransacthunk(data));
	};

	const updateInvo = (id, data) => {
		dispatch(updateInvoiceThunk(id, data));
	};

	const delInvo = (id) => {
		dispatch(deleteInvoiceThunk(id));
	};

	const search = (data) => {
		const filteredList = invoice.filter(
			(item) =>
				(item?.client?.fullname)
					.toLowerCase()
					.includes(data.toLowerCase()) ||
				(item?.client?.dni).includes(data) ||
				(item?.num_bill).includes(data) ||
				(item?.deliver_date).includes(data) ||
				(item?.seller.code).toLowerCase().includes(data) ||
				(item?.seller.name).toLowerCase().includes(data)
		);
		dispatch(setPagination(filteredList));
	};

	const [modalTransaccionPay, setModalTransaccionPay] = useState(false);
	const [itemSelect, setItemSelect] = useState("");

	const transaccionPay = (item) => {
		setModalTransaccionPay(true);
		setItemSelect(item);
	};

	const refresh = () => {
		dispatch(getInvoiceThunk());
		dispatch(getRouteDayThunk());
		dispatch(getSellerThunk());
		dispatch(getCustomerThunk());
	};

	const selecionSearch = (e) => {
		const { name, value } = e.target;
		// console.log(value);
	};
	const searchDB = [
		{ id: 1, detail: "LOCAL" },
		{ id: 2, detail: "BASE DATOS" },
	];
	const listAvailable = () => {
		return (
			<>
				<Formselectatom
					title={"Selecionar lugar de busqueda"}
					iterador={searchDB}
					dataSelect={selecionSearch}
					firstdata={"detail"}
					secunddata={"dia"}
					disabledAction={false}
				/>
			</>
		);
	};

	const [modalFilter, setModalFilter] = useState(false);
	const onHideFilter = () => {
		setModalFilter(false);
	};

	const generarArchivoExcel = (data, value) => {
		// Crear un nuevo libro de Excel
		dispatch(setIsLoading(true));
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet("Datos");

		// const sumBalance = data.reduce(
		// 	(total, obj) => total + parseFloat(obj.balance),
		// 	0
		// );
		// const sumTotal = data.reduce(
		// 	(total, obj) => total + parseFloat(obj.total_bill),
		// 	0
		// );

		worksheet.addRow([" ", " ", `Distribuidora de CHEO`]);
		worksheet.addRow([
			" ",
			`Generado Por: ${user.fullname}`,
			`Fecha: ${date.CurrendateDay()} ${date.Currendate()}`,
			`Tipo: ${user.username}`,
		]);
		worksheet.addRow([" ", " "]);
		worksheet.addRow([
			"ID",
			"Fecha",
			"Cliente",
			"Punto de Emision",
			"Punto de Establecimiento",
			"Numero de Factura",
			"Valor de Factura",
			"Abono Pago",
			"Saldo de Factura",
			"Tipo de Pago",
			"Numero de Proceso",
		]);

		//Valida si desea Descargar las facturas de forma general incluidas las Notas de ventas o solo Facturas
		value //Valida Facturas
			? data.forEach((datum) => {
					datum.isWhite //Si es nota de venta no la toma en cuenta
						? ""
						: worksheet.addRow([
								datum.id,
								`(${date.DatePastPresent(
									datum.deliver_date
								)})  ${datum.deliver_date}`,
								datum.client.fullname,
								"001",
								datum.num_bill.length > 13
									? datum.num_bill
									: datum.num_bill.match(/^\d{3}/)[0],
								datum.num_bill.length > 13
									? datum.num_bill
									: datum.num_bill.match(/-(\d+)$/)[1],
								// datum.num_bill,
								//
								`${parseFloat(datum.total_bill).toFixed(2)}`,
								"",
								`${parseFloat(datum.balance).toFixed(2)}`,
								datum.detail ? data.detail : "Credito",
								// datum.seller.name,
						  ]);

					if (!datum.isWhite) {
						let saldoAnterior = 0; // Inicializamos el saldo anterior en 0
						// Hacer una copia del array de transacciones antes de ordenarlo
						const transacOpertation = [...datum.transactions];

						const transaccionesFiltradas =
							transacOpertation.filter(
								(transc) =>
									!transc.detail.includes(
										"(Esta transaccion a sido eliminada,"
									)
							);
						// Ordenar las transacciones por fecha
						transaccionesFiltradas.sort(
							(a, b) =>
								new Date(a.balance_date) -
								new Date(b.balance_date)
						);

						transaccionesFiltradas.forEach((transc) => {
							if (transc.pay != 0) {
								// Sumar el saldo anterior al saldo actual
								const saldoActual =
									saldoAnterior + transc.pay;

								worksheet.addRow([
									datum.id,
									transc.balance_date,
									datum.client.fullname,
									"001",
									datum.num_bill.length > 13
										? datum.num_bill
										: datum.num_bill.match(
												/^\d{3}/
										  )[0],
									datum.num_bill.length > 13
										? datum.num_bill
										: datum.num_bill.match(
												/-(\d+)$/
										  )[1],
									`${parseFloat(datum.total_bill).toFixed(
										2
									)}`, // Total de la Factura
									`${parseFloat(transc.pay).toFixed(2)}`, // Total del ABono
									`${
										// parseFloat(saldoActual).toFixed(2)
										parseFloat(
											datum.total_bill - saldoActual
										).toFixed(2)
									}`, // Agregamos el saldo actual

									// "Hola que tal eejjej"
									transc.detail ? transc.detail : "EF",
								]);
								saldoAnterior = saldoActual;
							}
							// transc.pay != 0
							// 	? worksheet.addRow([
							// 			datum.id,
							// 			transc.balance_date,
							// 			datum.client.fullname,
							// 			"001",
							// 			datum.num_bill.length > 13
							// 				? datum.num_bill
							// 				: datum.num_bill.match(
							// 						/^\d{3}/
							// 				  )[0],
							// 			datum.num_bill.length > 13
							// 				? datum.num_bill
							// 				: datum.num_bill.match(
							// 						/-(\d+)$/
							// 				  )[1],
							// 			`${parseFloat(
							// 				datum.total_bill
							// 			).toFixed(2)}`,
							// 			`${parseFloat(transc.pay).toFixed(
							// 				2
							// 			)}`,
							// 			`${parseFloat(
							// 				datum.balance
							// 			).toFixed(2)}`,
							// 			// "Hola que tal eejjej"
							// 			transc.detail
							// 				? transc.detail
							// 				: "EF",
							// 	  ])
							// 	: ``;
							let newRow = worksheet.lastRow;
							transc.pay != 0
								? (newRow.fill = {
										type: "pattern",
										pattern: "solid",
										fgColor: { argb: "FFFF00" }, // Color de fondo amarillo
								  })
								: "";
						});
					}
					// datum.isWhite
					// 	? ""
					// 	: datum.transactions.forEach((transc) => {
					// 			transc.pay != 0
					// 				? worksheet.addRow([
					// 						datum.id,
					// 						transc.balance_date,
					// 						datum.client.fullname,
					// 						"001",
					// 						datum.num_bill.length > 13
					// 							? datum.num_bill
					// 							: datum.num_bill.match(
					// 									/^\d{3}/
					// 							  )[0],
					// 						datum.num_bill.length > 13
					// 							? datum.num_bill
					// 							: datum.num_bill.match(
					// 									/-(\d+)$/
					// 							  )[1],
					// 						`${parseFloat(
					// 							datum.total_bill
					// 						).toFixed(2)}`,
					// 						`${parseFloat(
					// 							transc.pay
					// 						).toFixed(2)}`,
					// 						`${parseFloat(
					// 							datum.balance
					// 						).toFixed(2)}`,
					// 						transc.detail
					// 							? transc.detail
					// 							: "EF",
					// 				  ])
					// 				: ``;
					// 			let newRow = worksheet.lastRow;
					// 			transc.pay != 0
					// 				? (newRow.fill = {
					// 						type: "pattern",
					// 						pattern: "solid",
					// 						fgColor: { argb: "FFFF00" }, // Color de fondo amarillo
					// 				  })
					// 				: "";
					// 	  });
			  }) //Valida Notas de Venta y  Facturas
			: data.forEach((datum) => {
					worksheet.addRow([
						datum.id,
						`(${date.DatePastPresent(datum.deliver_date)})  ${
							datum.deliver_date
						}`,
						datum.client.fullname,
						"001",
						datum.num_bill.length > 13
							? datum.num_bill
							: datum.num_bill.match(/^\d{3}/)[0],
						datum.num_bill.length > 13
							? datum.num_bill
							: datum.num_bill.match(/-(\d+)$/)[1],
						// datum.num_bill,
						//
						`${parseFloat(datum.total_bill).toFixed(2)}`,
						"",
						`${parseFloat(datum.balance).toFixed(2)}`,
						datum.detail ? data.detail : "Credito",
						// datum.seller.name,
					]);

					datum.transactions.forEach((transc) => {
						transc.pay != 0
							? worksheet.addRow([
									datum.id,
									transc.balance_date,
									datum.client.fullname,
									"001",
									datum.num_bill.length > 13
										? datum.num_bill
										: datum.num_bill.match(
												/^\d{3}/
										  )[0],
									datum.num_bill.length > 13
										? datum.num_bill
										: datum.num_bill.match(
												/-(\d+)$/
										  )[1],
									`${parseFloat(datum.total_bill).toFixed(
										2
									)}`,
									`${parseFloat(transc.pay).toFixed(2)}`,
									`${parseFloat(datum.balance).toFixed(
										2
									)}`,
									transc.detail ? transc.detail : "EF",
							  ])
							: ``;
						let newRow = worksheet.lastRow;
						transc.pay != 0
							? (newRow.fill = {
									type: "pattern",
									pattern: "solid",
									fgColor: { argb: "FFFF00" }, // Color de fondo amarillo
							  })
							: "";
					});
			  });

		// worksheet.addRow([
		// 	"",
		// 	"",
		// 	"",
		// 	"",
		// 	"",
		// 	"Totales:",
		// 	// `$ ${parseFloat(sumTotal).toFixed(2)}`,
		// 	// `$ ${parseFloat(sumBalance).toFixed(2)}`,
		// ]);
		// Generar el archivo Excel

		workbook.xlsx
			.writeBuffer()
			.then((buffer) => {
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				value
					? saveAs(blob, "datos-Facturas.xlsx")
					: saveAs(blob, "datos-general.xlsx");
			})
			.finally(dispatch(setIsLoading(false)));
	};
	// console.log(invoice);
	return (
		<div className="pages">
			<h2>Facturas</h2>
			<Functionalitiesbtn
				buttons={btnCreated}
				// listAvailable={listAvailable}
				search={search}
			/>

			<TableInvoice
				data={pagination}
				updateInvo={updateInvo}
				delInvo={delInvo}
				transaccionPay={transaccionPay}
				createInvo={createInvo}
			/>

			{!loading ? <Paginationdesign data={"invoice"} /> : <LoadingScreen />}
			<Createdcustomer
				show={modalShow}
				onHide={() => setModalShow(false)}
				title={"Created Customer"}
			/>
			{/* <ModalInvoiceTransac onHide={() => { setModalTransaccionPay(false) }} show={modalTransaccionPay} /> */}
			<ModalInvoiceTransac
				itemSelect={itemSelect}
				onhide={() => setModalTransaccionPay(false)}
				show={modalTransaccionPay}
			/>

			<Filterinvoice
				itemSelect={itemSelect}
				onhide={() => setModalFilter(false)}
				show={modalFilter}
			/>
		</div>
	);
};

export default Invoice;
